interface ProgressBarProps {
  value: number
  total: number
}

/** Same bar the training-diary plan banner uses, so progress reads alike. */
export function ProgressBar({ value, total }: ProgressBarProps) {
  const percent = total > 0 ? Math.min(100, Math.round((value / total) * 100)) : 0

  return (
    <div className="flex items-center gap-2">
      <div className="h-2 flex-1 overflow-hidden rounded-full bg-muted">
        <div className="h-full rounded-full bg-primary transition-all" style={{ width: `${percent}%` }} />
      </div>
      <span className="text-xs tabular-nums text-muted-foreground">
        {value}/{total}
      </span>
    </div>
  )
}
